import styled, { css } from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../../../../../styles/colors';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
  padding: 14px 20px;
  margin-bottom: 16px;
  border: 1px solid ${colors.shades.secondary7};
  border-radius: 5px;
  background-color: ${colors.shades.secondary10};
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StatLabel = styled(Typography)`
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${colors.shades.gamma10};
`;

const StatValue = styled(Typography)`
  font-size: 20px;
  font-weight: 500;
  color: ${colors.shades.secondary8};

  ${({ $isPriority }) => $isPriority && css`
    color: ${colors.shades.danger3};
  `}
`;

export {
  Container,
  Stat,
  StatLabel,
  StatValue,
};
